import { render, staticRenderFns } from "./TrustSigning.vue?vue&type=template&id=5d16d6bb&scoped=true"
import script from "./TrustSigning.vue?vue&type=script&lang=js"
export * from "./TrustSigning.vue?vue&type=script&lang=js"
import style0 from "./TrustSigning.vue?vue&type=style&index=0&id=5d16d6bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d16d6bb",
  null
  
)

export default component.exports